/* eslint-disable */
import { createSelector } from 'reselect';
import getFilters from './Filters.selector';

/**
 * Selects the `addresses` from `filters`
 * @returns {any} The addresses
 */
const getFiltersAddresses = createSelector(getFilters, (filters) => filters.addresses);

export default getFiltersAddresses;
